<div class="sidenav-content" @routeAnimation>
	<ng-container *ngIf="!isOffline; else offline">
		<ng-container *ngIf="!isLoading else loading">
			<copo-blocked-services-alert></copo-blocked-services-alert>
			<copo-news-alert></copo-news-alert>
			<copo-order-dashboard></copo-order-dashboard>
			<copo-dashboard-myservice></copo-dashboard-myservice>
			<copo-news-widget></copo-news-widget>
			<div class="dashboard-title-block">
				<div class="dashboard-title-label">
					<span translate>dashboard.key-information</span>
					<span *ngIf="informationEditMode"> - <span class="dashboard-configuration" translate>dashboard.widget-configuration</span></span>
				</div>
				<div class="dashboard-element-align-right">
					<button type="button" mat-button *ngIf="!informationEditMode" [ngClass]="{'dashboard-customize-button': !saving,'dashboard-customize-button-disable': saving}"
					(click)="toggleOnInformationEditMode()">
						<span *ngIf="!saving" translate>dashboard.customize-information</span>
						<span *ngIf="saving" translate>dashboard.saving</span>
						<mat-icon iconPositionEnd class="dashboard-icon" svgIcon="filters"></mat-icon>
					</button>
					<button type="button" mat-button *ngIf="informationEditMode" (click)="addNewWidget(INFORMATION)" class="dashboard-customize-button">
						<span translate>dashboard.add-widget</span>
						<mat-icon iconPositionEnd class="dashboard-icon" svgIcon="filters"></mat-icon>
					</button>
				</div>
			</div>
			<div class="copo-container footer-margin">
				<div class="information-grid-container" [sortablejs]="keyInformationWidgets" [sortablejsOptions]="sortablejsOptions">
					<div class="widget-element" [ngClass]="[getSpanSize(widgetInformation)]" [class.edit-mode]="informationEditMode" *ngFor="let widgetInformation of keyInformationWidgets">
						<div class="widget-element-title-bar">
							<span class="widget-element-title">
								<ng-container [ngSwitch]="widgetInformation.name">
									<span *ngSwitchCase="BIGGEST_STOCKS_WIDGET" translate>highest.stocks.widget.title</span>
									<span *ngSwitchCase="ISSUE_FOLLOW_UP_WIDGET" translate>issue.followup.widget.title</span>
									<span *ngSwitchCase="RTS_WIDGET" translate>materials.rts.widget.title</span>
								</ng-container>
							</span>
							<button type="button" mat-icon-button class="widget-icon" (click)="changeWidget(widgetInformation)"><mat-icon *ngIf="informationEditMode" svgIcon="filters"></mat-icon></button>
							<button type="button" mat-icon-button class="widget-icon" (click)="removeWidget(widgetInformation)"><mat-icon *ngIf="informationEditMode" svgIcon="md:close"></mat-icon></button>
						</div>
						<ng-container [ngSwitch]="widgetInformation.name">
							<copo-biggest-stocks-widget *ngSwitchCase="BIGGEST_STOCKS_WIDGET" [widget]="widgetInformation"></copo-biggest-stocks-widget>
							<copo-issue-widget *ngSwitchCase="ISSUE_FOLLOW_UP_WIDGET" [widget]="widgetInformation"></copo-issue-widget>
							<copo-rts-widget *ngSwitchCase="RTS_WIDGET" [widget]="widgetInformation"></copo-rts-widget>
						</ng-container>
					</div>
				</div>
				<div *ngIf="informationEditMode" class="save-cancel-button-block">
					<div class="save-cancel-button-container">
						<button type="button" mat-raised-button class="customize-button-secondary" (click)="cancelCustomizationInformationWidgets()">
							<span translate>dashboard.cancel</span>
						</button>
						<button type="button" mat-raised-button color="primary" class="customize-button-dark" (click)="validateCustomizationInformationWidgets()">
							<span translate>dashboard.validate</span>
						</button>
					</div>
				</div>
			</div>
		</ng-container>
	</ng-container>
	<ng-template #offline>
		<copo-offline></copo-offline>
	</ng-template>
	<ng-template #loading>
		<copo-loading-spinner></copo-loading-spinner>
	</ng-template>
</div>